<template>
    <div id="UserInfo">
        <div class="user-left">
            <div class="user-item name">
                <div>昵称</div>
                <el-input v-model="userForm.name" placeholder="请输入内容"></el-input>
            </div>
            <div class="user-item">
                <!--<img :src="$common.STATIC_URL + userForm.avatar" alt="">-->
                <div>头像</div>
                <el-avatar
                    :size="112"
                    :src="userForm.avatar ? userForm.avatar : $common.BASE_URL + '/img/profile.jpg'"
                    :key="userForm.avatar"
                    @click.native="upLoadImage"/>
                <input
                    style="display: none"
                    ref="input"
                    type="file"
                    accept="image/gif, image/jpeg, image/jpg, image/png, image/svg"
                    multiple="multiple"
                    @change="handleFileChange"
                >
            </div>
            <div class="user-item">
                <div>性别</div>
                <el-radio v-model="userForm.sex" label="男">男</el-radio>
                <el-radio v-model="userForm.sex" label="女">女</el-radio>
            </div>
            <!--<div class="user-item area">-->
            <!--    <div>城市</div>-->
            <!--    <el-select v-model="value" placeholder="请选择">-->
            <!--        <el-option>山东省</el-option>-->
            <!--    </el-select>-->
            <!--    <el-select v-model="value" placeholder="请选择">-->
            <!--        <el-option>济南</el-option>-->
            <!--    </el-select>-->
            <!--    <el-select v-model="value" placeholder="请选择">-->
            <!--        <el-option>历下区</el-option>-->
            <!--    </el-select>-->
            <!--</div>-->
            <div class="user-item phone">
                <!--<div>手机号</div>-->
                <!--<div>{{userForm}} <span>修改</span></div>-->
                <!--<div>1822552252</div>-->
            </div>
            <div class="user-item button">
                <el-button type="primary" @click="modifyUserInfo">修改资料</el-button>
            </div>
        </div>
        <div class="user-right">
            <div class="user-info-box">
                <el-avatar :size="64" :src="userForm.avatar ? userForm.avatar : $common.BASE_URL + '/img/profile.jpg'" :key="userForm.avatar"/>
                <p>{{userForm.name}}</p>
                <div>
                    <span>等级</span>
                    <img :src="score.img" alt="">
                </div>
                <div>
                    <span>总积分: {{score.score}}</span>
                    <!--<span>今日获得积分: 30</span>-->
                </div>
            </div>
            <div class="fans-box">
                <div>
                    <p>{{userForm.favorCount}}</p>
                    <p>关注</p>
                </div>
                <div>
                    <p>{{userForm.fansCount}}</p>
                    <p>粉丝</p>
                </div>
            </div>
            <div class="level-box">
                <div class="level-item" v-for="(item, index) of levelList" :key="index">
                    <span>{{item.level}}:</span>
                    <img :src="item.img" alt="">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'UserInfo',
        data() {
            return {
                userForm: {
                    name: '',
                    avatar: '',
                    sex: '',
                    addarea: ''
                },
                levelList: [
                    {level: '普通用户', img: require('../../assets/img/level/无星.png')},
                    {level: '一星用户', img: require('../../assets/img/level/1星.png')},
                    {level: '二星用户', img: require('../../assets/img/level/2星.png')},
                    {level: '三星用户', img: require('../../assets/img/level/3星.png')},
                    {level: '四星用户', img: require('../../assets/img/level/4星.png')},
                    {level: '一级会员用户', img: require('../../assets/img/level/一级会员.png')},
                    {level: '二级会员用户', img: require('../../assets/img/level/二级会员.png')},
                    {level: '三级会员用户', img: require('../../assets/img/level/三级会员.png')},
                    {level: '黄金会员用户', img: require('../../assets/img/level/黄金.png')},
                    {level: '铂金会员用户', img: require('../../assets/img/level/铂金.png')},
                    {level: '钻石会员用户', img: require('../../assets/img/level/钻石.png')}
                ],
                score: {
                    score: '0',
                    level: '',
                    lackScore: '',
                    percent: '',
                    img: ''
                }
            }
        },
        methods: {
            /**
             *  获取user信息
             * @return {Promise<void>}
             */
            async initUserInfo() {
                await this.$store.dispatch('getUser')
                this.userForm = Object.assign(this.userForm, this.$store.getters.getUser)
                this.getMyScore()
            },
            // 获得我的积分呢
            getMyScore() {
                this.$common.querystringifyPost('/hdweb/portal/getMyScore').then(res => {
                    this.score = res.data.data
                    this.levelList.map(item => {
                        if (item.level === this.score.level) {
                            this.score.img = item.img
                            return true
                        }
                    })
                })
            },
            /**
             * 上传图片
             */
            upLoadImage() {
                this.$refs.input.click()
            },
            /**
             * 上传图片回调
             * @param event
             */
            handleFileChange(event) {
                this.$common.uploadData('/hdweb/portal/uploadAvatar', {file: event.target.files[0]}).then(res => {
                    console.log(res)
                    if (res.data.code === 0) {
                        // this.$set(this.form.imgUrl, res.data.data)
                        this.userForm.avatar = res.data.data
                        // this.$set(this.userForm, 'avatar', res.data.data)
                    } else {
                        this.$message.error('上传失败')
                    }
                })
            },
            /**
             * 修改user信息
             */
            modifyUserInfo() {
                this.$common.querystringifyPost('/hdweb/portal/updateMember', this.userForm).then(res => {
                    console.log(res)
                    if (res.data.code === 0) {
                        this.$message.success(res.data.msg)
                        this.$store.dispatch('getUser')
                    } else {
                        this.$message.error(res.data.msg)
                    }
                })
            }
        },
        computed: {
            user() {
                return this.$store.getters.getUser
            }
        },
        mounted() {
            this.initUserInfo()
        }
    }
</script>

<style scoped lang="less">
    #UserInfo {
        width: 1200px;
        margin: 48px auto;
        display: flex;

        .user-left {
            width: calc(100% - 280px);

            .user-item {
                width: 720px;
                margin: 20px auto;
                display: flex;
                align-items: center;

                > div:nth-of-type(1) {
                    font-size: 14px;
                    width: 42px;
                    text-align: right;
                    margin-right: 18px;
                }
            }

            .phone {
                > div:nth-of-type(2) {
                    span {
                        color: rgba(5, 160, 130, 1);
                        cursor: pointer;
                    }
                }
            }

            .button {
                margin: 50px auto;
                width: 700px;
            }
        }

        .user-right {
            width: 280px;

            .user-info-box {
                width: 100%;
                height: 228px;
                border: 1px solid rgba(229, 229, 229, 1);
                border-bottom: none;
                text-align: center;
                padding-top: 25px;
                box-sizing: border-box;

                > p {
                    margin: 20px auto 20px;
                }

                > div {
                    margin: 20px auto;
                    width: 85%;
                    text-align: left;
                    display: flex;
                    align-items: center;

                    img {
                        margin-left: 10px;
                    }

                    &:nth-of-type(2) {
                        display: flex;
                        justify-content: space-between;
                    }
                }
            }

            .fans-box {
                display: flex;

                > div {
                    height: 70px;
                    width: 50%;
                    text-align: center;
                    border: 1px solid rgba(229, 229, 229, 1);

                    > p {
                        &:nth-of-type(1) {
                            font-size: 24px;
                            margin: 15px auto 8px;
                            color: rgba(34, 34, 34, 1);
                            font-weight: 600;
                        }
                    }
                }
            }

            .level-box {
                margin-top: 76px;

                .level-item {
                    height: 30px;
                    display: flex;
                    align-items: center;

                    img {
                        margin-left: 10px;
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/user/UserInfo.vue